import React from 'react';
import ConfigsForm from 'src/components/ConfigsForm';

const Configs = () => {
  return <ConfigsForm />;
};

export default Configs;
